<template>
  <v-card class="elevation-0">
    <v-card-title>
      <span class="headline" v-if="showHeader">Earnings And Deductions</span>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" label="Search Here" :class="classPadding"></v-text-field>
    </v-card-title>
    <v-card-text>
      <v-data-table :items="items" :headers="headers" :search="search">
          <template v-slot:item.actions="{ item }">
            <slot name="actions" v-bind:item="item"></slot>
          </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions } from "vuex";
// import EventBus from "../../../../events/eventBus";
const API_ENDPOINT = "/api/earnDeduc";
export default {
  props: {
    showHeader: {
      default: false,
      type: Boolean
    },
    earnType: {
      default: "",
      type: String
    }
  },
  data: () => ({
    search: "",
    items: [],
    headers: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "Code",
        value: "code",
        sortable: true
      },
      {
        text: "Description",
        value: "description",
        sortable: true
      }
    ],
    loading: false,
    classPadding: "my-0 py-0"
  }),
  methods: {
    ...mapActions("earningDeduction", ["select"]),
    getByEarnType() {
      this.loading = true;
      this.$axios
        .get(`${API_ENDPOINT}/earn/${this.earnType}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created() {
    //this.getAll();
    this.getByEarnType();
  },
  mounted() {
    // EventBus.$on("SELECTED_TYPEGROUP", type => {
    //   this.selectedType = type;
    //   this.getByType(type);
    // });
  }
};
</script>